/* Component Dependencies */
var pageTitleTemplate = require('templates/pageTitle.hbs');
var pageTitleHeadingTemplate = require('templates/pageTitle-heading.hbs');
var pageTitleSecondaryHeadingTemplate = require('templates/pageTitle-secondaryHeading.hbs');
var pageTileAccountMergeTemplate = require('templates/pageTitle-mergeAccount.hbs');
var pageTitleMergeAccountHeadingTemplate = require('templates/pageTitle-mergeAccountHeading.hbs');
var pageTitleCustomHeadingTemplate = require('templates/pageTitle-customHeading.hbs');
var pageTitleCheckInLookupTemplate = require('templates/pageTitle-checkInLookup.hbs');
var pageTitleCheckInTemplate = require('templates/pageTitle-checkInHeading.hbs');
var pageTitleCheckInConfirmationTemplate = require('templates/pageTitle-checkInConfirmation.hbs');
var pageTitleOCJModalTemplate = require('templates/pageTitle-ocjModal.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');

PubSub.register(AriesComponent.extend({
  type: 'pageTitle',
  template: {
    'pageTitle': pageTitleTemplate,
    'pageTitle-heading': pageTitleHeadingTemplate,
    'pageTitle-secondaryHeading': pageTitleSecondaryHeadingTemplate,
    'pageTitle-mergeAccount':pageTileAccountMergeTemplate,
    'pageTitle-mergeAccountHeading':pageTitleMergeAccountHeadingTemplate,
    'pageTitle-customHeading':pageTitleCustomHeadingTemplate,
    'pageTitle-checkInHeading': pageTitleCheckInTemplate,
    'pageTitle-checkInConfirmation': pageTitleCheckInConfirmationTemplate,
    'pageTitle-checkInLookup': pageTitleCheckInLookupTemplate,
    'pageTitle-ocjModal': pageTitleOCJModalTemplate
  },
  subscribe: {
    'TOGGLE_PAGE_HEADER': 'togglePageHeader'
  },
  togglePageHeader: function _togglePageHeader(isTileDisplayed){
    var _self=this;
    isTileDisplayed===true?_self.$el.removeClass('l-display-none').addClass('l-display-block'):_self.$el.removeClass('l-display-block').addClass('l-display-none');
  }
}));
